import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { errMsg } from "@/lib/errors";
import { UserPlus, UserCheck } from "lucide-react";

export default function FollowButton({ artistId, className = "" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [following, setFollowing] = useState(false);
  const [count, setCount] = useState(0);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/artists/${artistId}/followers`).then((r) => setCount(r.data.count));
    if (user) api.get(`/follows/check/${artistId}`).then((r) => setFollowing(r.data.following)).catch(() => {});
  }, [artistId, user]);

  const toggle = async () => {
    if (!user) { toast.error("Sign in to follow"); nav("/login"); return; }
    setBusy(true);
    try {
      if (following) {
        await api.delete(`/follows/${artistId}`);
        setFollowing(false); setCount((c) => Math.max(0, c - 1));
        toast.success("Unfollowed");
      } else {
        await api.post("/follows", { artist_id: artistId });
        setFollowing(true); setCount((c) => c + 1);
        toast.success("Following · you'll hear about new drops");
      }
    } catch (e) { toast.error(errMsg(e)); }
    finally { setBusy(false); }
  };

  return (
    <Button data-testid={`follow-btn-${artistId}`} onClick={toggle} disabled={busy}
            variant={following ? "outline" : "default"}
            className={`rounded-none font-mono text-xs uppercase tracking-widest h-10 px-4 ${following ? "border-[#FF4500] text-[#FF4500] bg-transparent hover:bg-[#FF4500]/10" : "bg-[#FF4500] hover:bg-[#E53E00] text-black"} ${className}`}>
      {following ? <><UserCheck className="h-4 w-4 mr-2" /> Following</> : <><UserPlus className="h-4 w-4 mr-2" /> Follow</>}
      <span className="ml-2 text-[10px] opacity-70">{count}</span>
    </Button>
  );
}
